import { TRootState } from '@/store/store';

export const getActiveTab = ({ contest }: TRootState) => contest.activeTab;
export const getTicketsAmount = ({ contest }: TRootState) => contest.ticketsAmount;
export const isProvablyFairModalVisible = ({ contest }: TRootState) => contest.isProvablyFairModalVisible;
